import { getObjectValue } from '@services/object-extensions';
import { Link, useParams } from 'react-router-dom';
import { Button } from '../button/button';

const ButtonGroup = ({ buttons = [], darkTheme = false, categoryId = '' }) => {
  const { idservice, idtechnology } = useParams();
  const sectionId = idservice ?? idtechnology;
  const base = idservice != null ? 'servizi-soluzioni' : 'tecnologie';

  return (
    <>
      {buttons?.map((element, index) => (
        <div className="row mb-4" key={`button-${index + 1}`}>
          <div className="col-12 p-0">
            <Link
              to={`/${base}/${sectionId}/category/${categoryId}/detail/${getObjectValue(
                element,
                'href',
                ''
              )}`}
            >
              <div>
                <Button darkTheme={darkTheme}>{getObjectValue(element, 'description', '')}</Button>
              </div>
            </Link>
          </div>
        </div>
      ))}
    </>
  );
};

ButtonGroup.displayName = 'Button Group';
export { ButtonGroup };
